import { render, staticRenderFns } from "./passGroupContent.vue?vue&type=template&id=464af850&scoped=true"
import script from "./passGroupContent.vue?vue&type=script&lang=js"
export * from "./passGroupContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464af850",
  null
  
)

export default component.exports